module.exports = __webpack_public_path__ + "static/banner_home_tablet2-f2d8521b2e4b196b49321a307da8be9e.jpg";